import TerminalnumBatchSendMessagesModal from './terminalnum-batch-send-messages-modal.vue'
export default TerminalnumBatchSendMessagesModal
